var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58336 12.1565H18.9166V9.12744H1.58336V12.1565ZM3.36047 7.82925H9.58239V4.79929H3.36047V7.82925ZM10.9167 7.82925H17.1385V4.79929H10.9167V7.82925ZM5.3605 2.20297H15.1386C16.0081 2.20297 16.749 2.745 17.0243 3.5011H3.47475C3.74999 2.745 4.49193 2.20297 5.3605 2.20297ZM18.4719 4.15069C18.4719 2.3605 16.9767 0.904785 15.1386 0.904785H5.3605C3.52241 0.904785 2.02717 2.3605 2.02717 4.15069V7.82925H0.25V17.0953H1.58336V13.4547H18.9166V17.0953H20.25V7.82925H18.4719V4.15069Z",
    fill: "#004087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBedBlue);
export default __webpack_public_path__ + "static/media/iconBedBlue.226a12e37d3f3a1af8cd0245b16c18aa.svg";
export { ForwardRef as ReactComponent };